import React from 'react';
import { MixpanelProvider } from 'react-mixpanel-browser';

const  Web = ({children}) => {
  return <MixpanelProvider token={process.env.MIXPANEL_TOKEN} log={true}>{children}</MixpanelProvider>;
};
export default Web;